<template lang="pug">
shListData(title="Usuarios" resolver="users" keyData="dni" component="shUser")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Users',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/user/Users.vue